module.exports = __webpack_public_path__ + "static/media/galdinsWon_25_50.c87248aa.png";